import * as React from "react"
import fetch from "isomorphic-fetch"

const LOCAL_ENDPOINT = "http://localhost:8888/.netlify/functions/cartContext"
const PROD_ENDPOINT =
  "https://www.filmfroth.com/.netlify/functions/cartContext"

const CART_ENDPOINT =
  process.env.NODE_ENV === "development" ? LOCAL_ENDPOINT : PROD_ENDPOINT

const defaultValues = {
  cart: [],
  isOpen: false,
  loading: false,
  onOpen: () => {},
  onClose: () => {},
  addVariantToCart: () => {},
  removeLineItem: () => {},
  updateLineItem: () => {},
  checkout: {
    lines: {
      edges: []
    },
  },
  searchTags: [],
  addTagToSearch: () => {},
  removeTagToSearch: () => {}
}

export const StoreContext = React.createContext(defaultValues)

const isBrowser = typeof window !== `undefined`
const localStorageKey = `shopify_checkout_id`

export const StoreProvider = ({ children }) => {
  const [checkout, setCheckout] = React.useState(defaultValues.checkout)
  const [searchTags, setSearchTags] = React.useState(defaultValues.searchTags)
  const [loading, setLoading] = React.useState(false)
  const [didJustAddToCart, setDidJustAddToCart] = React.useState(false)

  const setCheckoutItem = checkout => {
    if (isBrowser && checkout.cart !== null) {
      localStorage.setItem(localStorageKey, checkout.cart.id)
    }

    if(checkout.cart !== null){
      setCheckout(checkout.cart)
    }
  }

  React.useEffect(() => {
    const initializeCheckout = async () => {
      const existingCheckoutID = isBrowser
        ? localStorage.getItem(localStorageKey)
        : null
      fetch(CART_ENDPOINT, {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({ method: "get", id: existingCheckoutID }),
      })
        .then(response => response.json())
        .then(data => {
          setCheckoutItem(data.checkout)}
        )
    }

    initializeCheckout()
  }, [])

  const addVariantToCart = (variantId, quantity) => {
    setLoading(true)

    const checkoutID = checkout.id

    const lineItemsToUpdate = [
      {
        merchandiseId: variantId,
        quantity: parseInt(quantity, 10),
      },
    ]
    fetch(CART_ENDPOINT, {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({ method: "add", id: checkoutID, items: lineItemsToUpdate }),
      })
        .then(response => response.json())
        .then(data => {
          setCheckout(data.checkout.cart)
          setLoading(false)
          setDidJustAddToCart(true)
          setTimeout(() => setDidJustAddToCart(false), 3000)
        })
  }

  const removeLineItem = (checkoutID, lineID) => {
    setLoading(true)

    fetch(CART_ENDPOINT, {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({ method: "remove", id: checkoutID, items: lineID }),
      }).then(response => response.json())
      .then(data => {
        setCheckout(data.checkout.cart)
        setLoading(false)
      })
  }

  const updateLineItem = (checkoutID, lineID, lineItemID, quantity) => {
    setLoading(true)

    const lineItemsToUpdate = [
      { id: lineID, merchandiseId: lineItemID, quantity: parseInt(quantity, 10) },
    ]

    fetch(CART_ENDPOINT, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({
        method: "update",
        id: checkoutID,
        items: lineItemsToUpdate,
      }),
    })
      .then(response => response.json())
      .then(data => {
        setCheckout(data.checkout.cart)
        setLoading(false)
      })
  }

  const addTagToSearch = (tag) => {
    if(searchTags.indexOf(tag) >= 0) {
      return
    }
    const newTags = searchTags
    newTags.push(tag)
    setSearchTags(newTags)
  }

  const removeTagToSearch = (tag) => {
    const newTags = searchTags.filter(t => t !== tag)
    setSearchTags(newTags)
  }

  return (
    <StoreContext.Provider
      value={{
        ...defaultValues,
        addVariantToCart,
        removeLineItem,
        updateLineItem,
        checkout,
        loading,
        didJustAddToCart,
        searchTags,
        addTagToSearch,
        removeTagToSearch
      }}
    >
      {children}
    </StoreContext.Provider>
  )
}
